import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { SelectButton } from 'primereact/selectbutton';
import { akcizeApi } from '../../api/services';
import { useAlerts } from '../../custom/Alerts';
import { km as fmtKm, mesecNaziv } from './format';

const NACINI = [{ label: 'Km za mesec', value: 'km' }, { label: 'Stanje kilometar-sata', value: 'stanje' }];
const sledeciMesec = (k) => { const [g, m] = k.split('-').map(Number); return m === 12 ? `${g + 1}-01` : `${g}-${String(m + 1).padStart(2, '0')}`; };
const prviU = (k) => { const [g, m] = k.split('-'); return `01.${m}.${g}`; };

/** km vozila za mesec: operater potvrđuje procenu ili upisuje km (analogni tahograf nema DDD) — direktno ili kao stanje
    kilometar-sata na početku i kraju meseca (sa listića, servisne knjižice...). */
export default function KmDialog({ companyId, red, mesec, celija, onHide, onSacuvano }) {
    const alerts = useAlerts();
    const stanje = (celija.alternative || []).find((a) => a.izvor === 'stanje');
    const [nacin, setNacin] = useState('km');
    const [kmMes, setKmMes] = useState(celija.km);
    const [pocetak, setPocetak] = useState(stanje ? stanje.pocetak : null);
    const [kraj, setKraj] = useState(stanje ? stanje.kraj : null);
    const [napomena, setNapomena] = useState(celija.napomenaKm || '');
    const [radi, setRadi] = useState(false);
    const [g, m] = mesec.split('-').map(Number);
    const potvrdjeno = celija.izvor === 'rucno';
    const izStanja = pocetak != null && kraj != null && kraj >= pocetak ? kraj - pocetak : null;

    const sacuvaj = async () => {
        const body = { companyId, vehicleId: red.vehicleId, godina: g, mesec: m, napomena: napomena || null };
        if (nacin === 'stanje') {
            if (izStanja == null) { alerts.warn('Stanje na kraju meseca mora biti veće ili jednako stanju na početku.', 'Kilometri'); return; }
            Object.assign(body, { pocetak, kraj });
        } else {
            if (kmMes == null) { alerts.warn('Unesite kilometre za mesec.', 'Kilometri'); return; }
            body.km = kmMes;
        }
        setRadi(true);
        try {
            await akcizeApi.sacuvajKmMesec(body);
            alerts.success('Kilometri su potvrđeni.');
            onSacuvano();
        } catch { /* toast */ }
        setRadi(false);
    };
    const ponisti = async () => {
        if (!(await alerts.confirm('Poništi potvrdu', `Vratiti procenu za ${red.reg}, ${mesecNaziv(mesec)}? Ručno očitana stanja kilometar-sata ostaju.`))) return;
        setRadi(true);
        try { await akcizeApi.obrisiKmMesec({ companyId, vehicleId: red.vehicleId, godina: g, mesec: m }); onSacuvano(); } catch { /* toast */ }
        setRadi(false);
    };

    return (
        <Dialog header={`Kilometri — ${red.reg}, ${mesecNaziv(mesec)}`} visible onHide={onHide} style={{ width: 'min(34rem, 94vw)' }} modal draggable={false}
            footer={(
                <div className="dialog-footer">
                    {potvrdjeno && <Button label="Poništi potvrdu" icon="pi pi-undo" severity="danger" text onClick={ponisti} disabled={radi} />}
                    <Button label="Otkaži" text severity="secondary" onClick={onHide} />
                    <Button label="Potvrdi" icon="pi pi-check" onClick={sacuvaj} loading={radi} />
                </div>
            )}>
            <div className="form-section">
                <p className="akc-km-tren">
                    Trenutno: <b>{fmtKm(celija.km)} km</b>
                    {celija.izvorOpis && <span className={celija.potvrdjen ? 'akc-ok' : 'akc-procena'}> — {celija.izvorOpis}</span>}
                </p>
                {(celija.alternative || []).length > 0 && (
                    <ul className="akc-km-izvori" aria-label="Raspoloživi podaci">
                        {celija.alternative.map((a) => (
                            <li key={a.izvor}>
                                <span>{a.opis}{a.izvor === 'stanje' && a.pocetak != null ? ` (${fmtKm(a.pocetak)} → ${fmtKm(a.kraj)})` : ''}</span>
                                <b>{fmtKm(a.km)}</b>
                                <Button label="Preuzmi" text size="small" onClick={() => { setNacin('km'); setKmMes(a.km); }} aria-label={`Preuzmi ${a.opis}`} />
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            <SelectButton value={nacin} options={NACINI} onChange={(e) => e.value && setNacin(e.value)} className="akc-km-nacin" />
            <div className="form-grid">
                {nacin === 'km' ? (
                    <div className="field">
                        <label htmlFor="akc-kmm">Pređeno km u mesecu <span className="req">*</span></label>
                        <InputNumber inputId="akc-kmm" value={kmMes} onValueChange={(e) => setKmMes(e.value)} min={0} locale="sr-RS" useGrouping />
                    </div>
                ) : (
                    <>
                        <div className="field">
                            <label htmlFor="akc-poc">Stanje {prviU(mesec)} <span className="req">*</span></label>
                            <InputNumber inputId="akc-poc" value={pocetak} onValueChange={(e) => setPocetak(e.value)} min={0} locale="sr-RS" useGrouping />
                        </div>
                        <div className="field">
                            <label htmlFor="akc-kraj">Stanje {prviU(sledeciMesec(mesec))} <span className="req">*</span></label>
                            <InputNumber inputId="akc-kraj" value={kraj} onValueChange={(e) => setKraj(e.value)} min={0} locale="sr-RS" useGrouping />
                        </div>
                        <p className="muted" style={{ gridColumn: '1 / -1', margin: 0 }}>
                            Pređeno: <b>{izStanja == null ? '—' : `${fmtKm(izStanja)} km`}</b>. Stanja se čuvaju i koriste za procenu susednih meseci.
                        </p>
                    </>
                )}
                <div className="field" style={{ gridColumn: '1 / -1' }}>
                    <label htmlFor="akc-kmnap">Osnov (napomena)</label>
                    <InputText id="akc-kmnap" value={napomena} maxLength={200} onChange={(e) => setNapomena(e.target.value)} placeholder="Analogni listić, servisna knjižica, putni nalog…" />
                </div>
            </div>
        </Dialog>
    );
}
